module.exports = __webpack_public_path__ + "static/img/active_hb1.8e5868aa.png";